import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  fireAnimation,
  formateNumberStNdRd,
  GetDealerdata,
  getMillisecond,
  handlePostApiGF,
  shareIphonePostMsg,
  ShareurlWithImg,
  Toast,
} from "../../Utils/general-function";
import { confirmAlert } from "react-confirm-alert";
import { Modal } from "react-bootstrap";
import { useScrollRestoration } from "../../hooks/useScrollRestoration";
import GenerateVehicleQrCmn from "../../Utils/GenerateVehicleQrCmn";
import shareImg from "../../../src_img/share.png";
import eyeImg from "../../../src_img/eye.png";
function Innerlistcommon({ catloguelist, onDataChangeProp, scrollKey, from }) {
  const [state, setState] = useState({
    Branding: "W_hB",
    show: false,
    clickedObj: "",
  });
  const iphone = window.navigator.userAgent.includes("Mac");
  const [dealerData, setDealerData] = useState({});
  const params = useParams();
  useScrollRestoration(scrollKey); // Custom hook to restore scroll position

  useEffect(() => {
    GetDealerdata().then((res) => {
      setDealerData(res);
    });
  }, []);

  const soldCar = async ({ list }) => {
    const res = await handlePostApiGF({
      url: `/api/Carmaster/changesoldunsoldstatus?carno=${list?.carnumber}&carstatus=${list?.CarStatus}`,
    });

    if (res?.succ) {
      const updated = [...catloguelist].filter(
        (data) => data?.carnumber !== list?.carnumber,
      ); // remove sold car from list which is displayed to user and send back to parent and these list will be show to user

      onDataChangeProp?.({ catloguelists: updated, targetedsoldcar: list }); //targetedsoldcar: removed sold car from original list so will not show to user again on searching etc because on searching original list is used to filter data and purpose: no need to call api again to get updated list for original list
      fireAnimation();
    }
  };

  function GetConfirmation({ list }) {
    confirmAlert({
      customUI: ({ onClose }) => {
        window.addEventListener("popstate", onClose);
        return (
          <div className="popup-overlay px-3 py-3 text-center">
            <p>Are you sure you want to Sold this vehicle?</p>
            <p style={{ fontSize: "14px", color: "red" }}>
              Note: Selling the vehicle deletes it from the catalog along with
              all uploaded photos.
            </p>
            <button
              className="submitbtn me-2 popup-btn"
              onClick={() => {
                soldCar({ list });
                onClose();
              }}
            >
              Yes
            </button>
            <button
              className="submitbtn me-2 popup-btn"
              onClick={() => {
                onClose();
              }}
            >
              No
            </button>
          </div>
        );
      },
    });
  }
  // console.log(onDataChangeProp);

  function handleShareMdl() {
    // setShow(!show);
    // setBranding("W_hB"); //reseting defalult share option on closing modal
    setState((prev) => ({ ...prev, Branding: "W_hB", show: !prev.show }));
  }

  const Onchange = (e) => {
    const { name, value } = e.target;
    // setBranding(e.target.value);
    setState((prev) => ({ ...prev, [name]: value }));
  };

  let onShareBtn = ({ obj }) => {
    setState((prev) => ({ ...prev, clickedObj: obj, show: true }));
  };

  // const OnDelete = (random, password) => {
  //   const header = {
  //     headers: {
  //       Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
  //     },
  //   };
  //   fetch(
  //     process.env.REACT_APP_API_ENDPOINT +
  //       "/api/Carmaster/Delete?Rand=" +
  //       random +
  //       "&password=" +
  //       encodeURIComponent(password) +
  //       "&action=ForTrash",
  //     header
  //   )
  //     .then((response) => response.json())
  //     .then((res) => {
  //       if (res.Success) {
  //         let updatelist = catloguelist.filter((d) => d.Rand !== random);
  //         let removedCar = catloguelist.find((d) => d.Rand === random);

  //         onDataChangeProp?.({
  //           catloguelists: updatelist,
  //           targetedsoldcar: removedCar,
  //         });
  //       }
  //       Toast(res.Success, res.Message, res.Message);
  //     });
  // };

  // const opendeletepopup = (random) => {
  //   confirmAlert({
  //     customUI: ({ onClose }) => {
  //       window.addEventListener("popstate", onClose);
  //       return (
  //         <div className="popup-overlay px-3 py-3 text-center">
  //           <p className="mb-0">
  //             {" "}
  //             Are you sure, you want to move this car to the trash bin?
  //           </p>
  //           <div className="mb-2" style={{ fontSize: "12px" }}>
  //             (Deleted cars are kept in "Trash Bin" for 90 days.)
  //           </div>
  //           <button
  //             className="submitbtn me-2 popup-btn"
  //             onClick={() => {
  //               OnDelete(random, "");
  //               onClose();
  //             }}
  //           >
  //             Yes
  //           </button>
  //           <button
  //             className="submitbtn me-2 popup-btn"
  //             onClick={() => {
  //               onClose();
  //             }}
  //           >
  //             No
  //           </button>
  //         </div>
  //       );
  //     },
  //   });
  // };

  const { Branding, clickedObj, show } = state;
  console.log("clickedObj", clickedObj);

  return (
    <>
      {catloguelist.map((list, index) => (
        <div
          className="oldcatlg-div"
          id={`carToScroll-${list.Rand}`} // show last view car when come back from more detail
          key={list.carid}
          style={{ padding: 0 }}
        >
          {/* <div className="d-flex"> */}
          <div className="catlg-img d-flex w-100 border-none">
            <Link to={"/Catlogue_Detail/" + list.Rand} style={{ flex: "1" }}>
              <img
                src={`${list.carphoto}?v=${getMillisecond(list?.nUpdatedate)}`}
                className="img-fluid"
                alt=""
              />
            </Link>
            <div className="oldcatlg-text mb-2" style={{ flex: "2" }}>
              {/* <h2 className="pt-2">
                {list.modelyear} {list.companyid} {list.carmodelid}{" "}
                {list.variantid}
              </h2> */}
              <div
                className="d-flex pt-2"
                style={{ justifyContent: "space-between" }}
              >
                <h2>
                  {list.modelyear} {list.companyid} {list.carmodelid}{" "}
                  {list.variantid}
                </h2>
                {list.nCaravaibility === "Yes" && (
                  <div>
                    <p
                      style={{
                        whiteSpace: "nowrap",
                        fontSize: "10px",
                        color: "rgb(255, 255, 255)",
                        background:
                          "linear-gradient(rgb(8, 153, 223) 0%, rgb(8, 153, 223) 100%)",
                        padding: "2px 4px",
                        borderRadius: "8px",
                      }}
                    >
                      Coming Soon
                    </p>
                  </div>
                )}
              </div>
              <div className="oldcatlg-number">
                <span>{list.carnumber}</span>
                {list.km && <span> • {list.km} km</span>}
                <span> • {list.fueltypeid} </span>
                <span> • {list.gear} </span>
                {list.nSaleprice && (
                  <>
                    <span>•</span>
                    <span style={{ fontWeight: "400", color: "red" }}>
                      {" "}
                      ₹{Intl.NumberFormat("en-IN").format(list.nSaleprice)}
                    </span>
                  </>
                )}
                {list.npricerate && <span> • {list.npricerate}</span>}
                <span> • {formateNumberStNdRd(list?.owner)} Owner</span>
              </div>

              {/*  new end*/}
            </div>
          </div>

          <div
            className="p-2 d-flex align-items-center flex-wrap"
            style={{ gap: "6px" }}
          >
            <Link
              to={"/Statuspage/"}
              state={{ details: list }}
              className="mdbtn bgTranTextBlackHover"
              style={{
                border: "1px solid red",
                color: "black",
                backgroundColor: "transparent",
                padding: "8px 4px",
              }}
            >
              Create Status
            </Link>
            <button
              className="mdbtn mt-0  bgTranTextBlackHover"
              onClick={() => GetConfirmation({ list })}
              style={{
                border: "1px solid red",
                color: "black",
                backgroundColor: "transparent",
                padding: "8px 4px",
              }}
            >
              Mark as Sold
            </button>

            <GenerateVehicleQrCmn data={list} dealerData={dealerData} />
            <Link
              to={"/Catlogue_Detail/" + list.Rand}
              className="mdbtn bg-transparent p-0 bgTranTextBlackHover radius4"
            >
              <span
                className="material-symbols-outlined bgTranTextBlackHover radius4"
                style={{ border: "1px solid red", color: "#000" }}
              >
                visibility
              </span>
            </Link>

            <span
              className="material-symbols-outlined bgTranTextBlackHover radius4"
              style={{ border: "1px solid red", color: "#000" }}
              onClick={() => onShareBtn({ obj: list })}
            >
              share
            </span>
            <Link
              to="/Editinquiry"
              state={{ random: list.Rand, from }}
              className="mt-0"
            >
              <img
                src="assets/images/edit-car.png"
                className="scale"
                alt="Edit"
                height={27}
                width={27}
              />
            </Link>
          </div>

          {/* old whhere eddit button show below */}
          {/* <div className="p-2 d-flex align-items-center flex-wrap gap-2">
            <Link
              to={"/Statuspage/"}
              state={{ details: list }}
              className="mdbtn bgTranTextBlackHover"
              style={{
                border: "1px solid red",
                color: "black",
                backgroundColor: "transparent",
              }}
            >
              Create Status
            </Link>
            <button
              className="mdbtn mt-0  bgTranTextBlackHover"
              onClick={() => GetConfirmation({ list })}
              style={{
                border: "1px solid red",
                color: "black",
                backgroundColor: "transparent",
              }}
            >
              Mark as Sold
            </button>

            <GenerateVehicleQrCmn data={list} dealerData={dealerData} />
            <Link
              to={"/Catlogue_Detail/" + list.Rand}
              className="mdbtn bg-transparent p-0 bgTranTextBlackHover radius4"
            >
              <span
                className="material-symbols-outlined bgTranTextBlackHover radius4"
                style={{ border: "1px solid red", color: "#000" }}
              >
                visibility
              </span>
            </Link>

            <span
              className="material-symbols-outlined bgTranTextBlackHover radius4"
              style={{ border: "1px solid red", color: "#000" }}
              onClick={() => onShareBtn({ obj: list })}
            >
              share
            </span>
            <Link
              to="/Editinquiry"
              state={{ random: list.Rand, from }}
              className="mt-0"
            >
              <img
                src="assets/images/edit-car.png"
                className="scale"
                alt="Edit"
                height={27}
                width={27}
              />
            </Link>
           
          </div> */}
        </div>
      ))}

      <Modal
        show={show}
        onHide={(e) => handleShareMdl()}
        id="resultpopup"
        className="modal"
      >
        <Modal.Header closeButton>
          <h4 className="modal-title">Choose Share with</h4>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <div className="form-div">
              <div>
                <div className="form-check-inline">
                  <input
                    type="radio"
                    className="form-check-input"
                    id="radio3"
                    name="Branding"
                    value="W_hB"
                    onChange={Onchange}
                    defaultChecked
                  />
                  <label className="form-check-label px-1" htmlFor="radio3">
                    With Branding
                  </label>
                </div>
                <div className="form-check-inline">
                  <input
                    type="radio"
                    className="form-check-input"
                    id="radio4"
                    name="Branding"
                    value="Wo_hB"
                    onChange={Onchange}
                  />
                  <label className="form-check-label px-1" htmlFor="radio4">
                    Without Branding
                  </label>
                </div>
                {/* only indiviual car photo share option */}
                <div className="form-check-inline mt-2">
                  <input
                    type="radio"
                    className="form-check-input"
                    id="radio5"
                    name="Branding"
                    value="onlyPhoto"
                    onChange={Onchange}
                  />
                  <label className="form-check-label px-1" htmlFor="radio5">
                    Without detail (only photo)
                  </label>
                </div>
                <div className="text-center mt-4">
                  <input
                    type="submit"
                    value="Share"
                    className="attachbtn"
                    onClick={(e) => {
                      const url =
                        Branding === "onlyPhoto"
                          ? new URL(
                              `/#/IndividualCarPhotoShare/${
                                clickedObj.Rand
                              }/${localStorage.getItem("Ca1itd")}`,
                              window.location.origin,
                            ).href
                          : new URL(
                              `/#/CatDetails/${
                                clickedObj.Rand
                              }/${localStorage.getItem("Ca1itd")}/${Branding}`,
                              window.location.origin,
                            ).href;

                      // iphone
                      //   ? shareIphonePostMsg({ action: "urlshare", url })
                      //   : Shareurl(url);
                      iphone
                        ? shareIphonePostMsg({ action: "urlshare", url })
                        : ShareurlWithImg({
                            url,
                            text: `${clickedObj?.modelyear} ${clickedObj?.companyid} ${clickedObj?.carmodelid} ${clickedObj?.variantid}`,
                          });

                      handleShareMdl();
                    }}
                  />
                </div>
                {/* end */}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Innerlistcommon;

// import React, { useEffect, useState } from "react";
// import { Link, useParams } from "react-router-dom";
// import {
//   fireAnimation,
//   GetDealerdata,
//   getMillisecond,
//   handlePostApiGF,
//   shareIphonePostMsg,
//   ShareurlWithImg,
//   Toast,
// } from "../../Utils/general-function";
// import { confirmAlert } from "react-confirm-alert";
// import { Modal } from "react-bootstrap";
// import { useScrollRestoration } from "../../hooks/useScrollRestoration";
// import GenerateVehicleQrCmn from "../../Utils/GenerateVehicleQrCmn";
// import shareImg from "../../../src_img/share.png";
// import eyeImg from "../../../src_img/eye.png";
// function Innerlistcommon({ catloguelist, onDataChangeProp, scrollKey, from }) {
//   const [state, setState] = useState({
//     Branding: "W_hB",
//     show: false,
//     clickedObj: "",
//   });
//   const iphone = window.navigator.userAgent.includes("Mac");
//   const [dealerData, setDealerData] = useState({});
//   const params = useParams();
//   useScrollRestoration(scrollKey); // Custom hook to restore scroll position

//   useEffect(() => {
//     GetDealerdata().then((res) => {
//       setDealerData(res);
//     });
//   }, []);

//   const soldCar = async ({ list }) => {
//     const res = await handlePostApiGF({
//       url: `/api/Carmaster/changesoldunsoldstatus?carno=${list?.carnumber}&carstatus=${list?.CarStatus}`,
//     });

//     if (res?.succ) {
//       const updated = [...catloguelist].filter(
//         (data) => data?.carnumber !== list?.carnumber
//       ); // remove sold car from list which is displayed to user and send back to parent and these list will be show to user

//       onDataChangeProp?.({ catloguelists: updated, targetedsoldcar: list }); //targetedsoldcar: removed sold car from original list so will not show to user again on searching etc because on searching original list is used to filter data and purpose: no need to call api again to get updated list for original list
//       fireAnimation();
//     }
//   };

//   function GetConfirmation({ list }) {
//     confirmAlert({
//       customUI: ({ onClose }) => {
//         window.addEventListener("popstate", onClose);
//         return (
//           <div className="popup-overlay px-3 py-3 text-center">
//             <p>Are you sure you want to Sold this vehicle?</p>
//             <p style={{ fontSize: "14px", color: "red" }}>
//               Note: Selling the vehicle deletes it from the catalog along with
//               all uploaded photos.
//             </p>
//             <button
//               className="submitbtn me-2 popup-btn"
//               onClick={() => {
//                 soldCar({ list });
//                 onClose();
//               }}
//             >
//               Yes
//             </button>
//             <button
//               className="submitbtn me-2 popup-btn"
//               onClick={() => {
//                 onClose();
//               }}
//             >
//               No
//             </button>
//           </div>
//         );
//       },
//     });
//   }
//   // console.log(onDataChangeProp);

//   function handleShareMdl() {
//     // setShow(!show);
//     // setBranding("W_hB"); //reseting defalult share option on closing modal
//     setState((prev) => ({ ...prev, Branding: "W_hB", show: !prev.show }));
//   }

//   const Onchange = (e) => {
//     const { name, value } = e.target;
//     // setBranding(e.target.value);
//     setState((prev) => ({ ...prev, [name]: value }));
//   };

//   let onShareBtn = ({ obj }) => {
//     setState((prev) => ({ ...prev, clickedObj: obj, show: true }));
//   };

//   const OnDelete = (random, password) => {
//     const header = {
//       headers: {
//         Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
//       },
//     };
//     fetch(
//       process.env.REACT_APP_API_ENDPOINT +
//         "/api/Carmaster/Delete?Rand=" +
//         random +
//         "&password=" +
//         encodeURIComponent(password) +
//         "&action=ForTrash",
//       header
//     )
//       .then((response) => response.json())
//       .then((res) => {
//         if (res.Success) {
//           let updatelist = catloguelist.filter((d) => d.Rand !== random);
//           let removedCar = catloguelist.find((d) => d.Rand === random);

//           onDataChangeProp?.({
//             catloguelists: updatelist,
//             targetedsoldcar: removedCar,
//           });
//         }
//         Toast(res.Success, res.Message, res.Message);
//       });
//   };

//   // const opendeletepopup = (random) => {
//   //   confirmAlert({
//   //     customUI: ({ onClose }) => {
//   //       window.addEventListener("popstate", onClose);
//   //       return (
//   //         <div className="popup-overlay px-3 py-3 text-center">
//   //           <p className="mb-0">
//   //             {" "}
//   //             Are you sure, you want to move this car to the trash bin?
//   //           </p>
//   //           <div className="mb-2" style={{ fontSize: "12px" }}>
//   //             (Deleted cars are kept in "Trash Bin" for 90 days.)
//   //           </div>
//   //           <button
//   //             className="submitbtn me-2 popup-btn"
//   //             onClick={() => {
//   //               OnDelete(random, "");
//   //               onClose();
//   //             }}
//   //           >
//   //             Yes
//   //           </button>
//   //           <button
//   //             className="submitbtn me-2 popup-btn"
//   //             onClick={() => {
//   //               onClose();
//   //             }}
//   //           >
//   //             No
//   //           </button>
//   //         </div>
//   //       );
//   //     },
//   //   });
//   // };

//   const { Branding, clickedObj, show } = state;

//   return (
//     <>
//       {catloguelist.map((list, index) => (
//         <div
//           className="oldcatlg-div"
//           id={`carToScroll-${list.Rand}`} // show last view car when come back from more detail
//           key={list.carid}
//           style={{ padding: 0 }}
//         >
//           {/* <div className="d-flex"> */}
//           <div className="catlg-img d-flex w-100 border-none">
//             <Link to={"/Catlogue_Detail/" + list.Rand} style={{ flex: "1" }}>
//               <img
//                 src={`${list.carphoto}?v=${getMillisecond(list?.nUpdatedate)}`}
//                 className="img-fluid"
//                 alt=""
//               />
//             </Link>
//             <div className="oldcatlg-text mb-2" style={{ flex: "2" }}>
//               <h2 className="pt-2">
//                 {list.modelyear} {list.companyid} {list.carmodelid}{" "}
//                 {list.variantid}
//               </h2>

//               <div className="oldcatlg-number">
//                 <span>{list.carnumber}</span>
//                 <span> • {list.km} km</span>
//                 <span> • {list.fueltypeid} </span>
//                 <span> • {list.gear} </span>
//                 {list.nSaleprice && (
//                   <>
//                     <span>•</span>
//                     <span style={{ fontWeight: "400", color: "red" }}>
//                       {" "}
//                       ₹{Intl.NumberFormat("en-IN").format(list.nSaleprice)}
//                     </span>
//                   </>
//                 )}
//               </div>

//               {/*  new end*/}
//             </div>
//           </div>

//           <div className="p-2 d-flex align-items-center flex-wrap gap-2">
//             <Link
//               to={"/Statuspage/"}
//               state={{ details: list }}
//               className="mdbtn bgTranTextBlackHover"
//               style={{
//                 border: "1px solid red",
//                 color: "black",
//                 backgroundColor: "transparent",
//               }}
//             >
//               Create Status
//             </Link>
//             <button
//               className="mdbtn mt-0  bgTranTextBlackHover"
//               onClick={() => GetConfirmation({ list })}
//               style={{
//                 border: "1px solid red",
//                 color: "black",
//                 backgroundColor: "transparent",
//               }}
//             >
//               Mark as Sold
//             </button>

//             <GenerateVehicleQrCmn data={list} dealerData={dealerData} />
//             <Link
//               to={"/Catlogue_Detail/" + list.Rand}
//               className="mdbtn bg-transparent p-0 bgTranTextBlackHover radius4"
//             >
//               <span
//                 className="material-symbols-outlined bgTranTextBlackHover radius4"
//                 style={{ border: "1px solid red", color: "#000" }}
//               >
//                 visibility
//               </span>
//             </Link>

//             <span
//               className="material-symbols-outlined bgTranTextBlackHover radius4"
//               style={{ border: "1px solid red", color: "#000" }}
//               onClick={() => onShareBtn({ obj: list })}
//             >
//               share
//             </span>
//             <Link
//               to="/Editinquiry"
//               state={{ random: list.Rand, from }}
//               className="mt-0"
//             >
//               <img
//                 src="assets/images/edit-car.png"
//                 className="scale"
//                 alt="Edit"
//                 height={27}
//                 width={27}
//               />
//             </Link>
//             {/* <button
//               style={{
//                 marginTop: "0px",
//                 border: "none",
//                 padding: "0px",
//                 background: "none",
//               }}
//               className="scale innerlist-delete-btn"
//               onClick={(e) => opendeletepopup(list.Rand)}
//             >
//               <img
//                 src="assets/images/delete-car.png"
//                 height={27}
//                 width={27}
//                 alt=""
//               />
//             </button> */}
//           </div>
//         </div>
//       ))}

//       <Modal
//         show={show}
//         onHide={(e) => handleShareMdl()}
//         id="resultpopup"
//         className="modal"
//       >
//         <Modal.Header closeButton>
//           <h4 className="modal-title">Choose Share with</h4>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="text-center">
//             <div className="form-div">
//               <div>
//                 <div className="form-check-inline">
//                   <input
//                     type="radio"
//                     className="form-check-input"
//                     id="radio3"
//                     name="Branding"
//                     value="W_hB"
//                     onChange={Onchange}
//                     defaultChecked
//                   />
//                   <label className="form-check-label px-1" htmlFor="radio3">
//                     With Branding
//                   </label>
//                 </div>
//                 <div className="form-check-inline">
//                   <input
//                     type="radio"
//                     className="form-check-input"
//                     id="radio4"
//                     name="Branding"
//                     value="Wo_hB"
//                     onChange={Onchange}
//                   />
//                   <label className="form-check-label px-1" htmlFor="radio4">
//                     Without Branding
//                   </label>
//                 </div>
//                 {/* only indiviual car photo share option */}
//                 <div className="form-check-inline mt-2">
//                   <input
//                     type="radio"
//                     className="form-check-input"
//                     id="radio5"
//                     name="Branding"
//                     value="onlyPhoto"
//                     onChange={Onchange}
//                   />
//                   <label className="form-check-label px-1" htmlFor="radio5">
//                     Without detail (only photo)
//                   </label>
//                 </div>
//                 <div className="text-center mt-4">
//                   <input
//                     type="submit"
//                     value="Share"
//                     className="attachbtn"
//                     onClick={(e) => {
//                       const url =
//                         Branding === "onlyPhoto"
//                           ? new URL(
//                               `/#/IndividualCarPhotoShare/${
//                                 clickedObj.Rand
//                               }/${localStorage.getItem("Ca1itd")}`,
//                               window.location.origin
//                             ).href
//                           : new URL(
//                               `/#/CatDetails/${
//                                 clickedObj.Rand
//                               }/${localStorage.getItem("Ca1itd")}/${Branding}`,
//                               window.location.origin
//                             ).href;

//                       // iphone
//                       //   ? shareIphonePostMsg({ action: "urlshare", url })
//                       //   : Shareurl(url);
//                       iphone
//                         ? shareIphonePostMsg({ action: "urlshare", url })
//                         : ShareurlWithImg({
//                             url,
//                             imgUrl: clickedObj?.carphoto || "",
//                           });

//                       handleShareMdl();
//                     }}
//                   />
//                 </div>
//                 {/* end */}
//               </div>
//             </div>
//           </div>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// }

// export default Innerlistcommon;
